<!-- PROGRESS BAR -->
<fuse-progress-bar></fuse-progress-bar>
<!-- / PROGRESS BAR -->

<!-- VERTICAL LAYOUT 1 -->
<vertical-layout></vertical-layout>
<!-- / VERTICAL LAYOUT 1 -->

<!--<fuse-sidebar name="themeOptionsPanel" class="theme-options-sidebar" position="right" [invisibleOverlay]="true">-->
<!--    <fuse-theme-options></fuse-theme-options>-->
<!--</fuse-sidebar>-->

<simple-notifications></simple-notifications>
